/* eslint-disable redos/no-vulnerable */
import type { Fragment } from '../../api/search/interface';

const CITATION = /\[(\d+|x)]\(\s*(%7B[^)]+%7D)\s*\)/g;

const RUN_SEPARATOR = /^[ \t]*$/;

export type CitationMapItem = Fragment & { citationNumber: string };

export interface ExtractedCitations {
  text: string;
  groups: Record<string, CitationMapItem[]>;
}

export function extractCitationGroups(markdown: string): ExtractedCitations {
  const groups: Record<string, CitationMapItem[]> = {};
  if (!markdown) {
    return { text: markdown ?? '', groups };
  }

  let out = '';
  let cursor = 0;
  let openKey: string | null = null;
  let runEnd = -1;

  CITATION.lastIndex = 0;
  let match: RegExpExecArray | null;
  while ((match = CITATION.exec(markdown)) !== null) {
    let item: CitationMapItem;
    try {
      const jsonString = decodeURIComponent(match[2]).replace(/\+\s*/g, '');
      item = { ...JSON.parse(jsonString), citationNumber: match[1] };
    } catch {
      openKey = null;
      continue;
    }

    const start = match.index;
    const end = start + match[0].length;
    const continuesRun =
      openKey !== null && RUN_SEPARATOR.test(markdown.slice(runEnd, start));

    if (continuesRun) {
      groups[openKey!].push(item);
    } else {
      out += markdown.slice(cursor, start);
      out += `[${start}](citation-${start})`;
      openKey = `${start}`;
      groups[openKey] = [item];
    }
    cursor = end;
    runEnd = end;
  }

  out += markdown.slice(cursor);
  return { text: out, groups };
}
